import { render, staticRenderFns } from "./uxIssuePanel.vue?vue&type=template&id=6259c88b&"
import script from "./uxIssuePanel.vue?vue&type=script&lang=js&"
export * from "./uxIssuePanel.vue?vue&type=script&lang=js&"
import style0 from "./uxIssuePanel.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports